module.exports = __webpack_public_path__ + "img/device-management.520b1d33.webp";